import {
  IonContent,
  IonHeader,
  IonPage,
  IonToolbar,
  useIonRouter,
} from "@ionic/react";
import { HStack } from "../components/utils";
import { ChevronLeft } from "akar-icons";
import { ForecastChartForGrant } from "./ForeCastChartForGrant";

const WealthForecastForGrant: React.FC = () => {
  const router = useIonRouter();
  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <HStack className="items-center justify-between max-w-md mx-auto my-2">
            <ChevronLeft
              className="w-7"
              size={20}
              onClick={() => {
                if (router.canGoBack()) {
                  router.goBack();
                }
                else {
                  router.push("/tabs/evaluate", "back");
                }
              }}
            />
            <p className="text-primary text-lg font-semibold">Wealth Forecast</p>
            <div className="w-7"></div>
          </HStack>
        </IonToolbar>
      </IonHeader>
      <IonContent fullscreen>
        <div className="max-w-md mx-auto mb-5">
          <ForecastChartForGrant />
        </div>
      </IonContent>
    </IonPage>
  );
};

export default WealthForecastForGrant;
